import styled from 'styled-components';
import { PAGE_CONTAINER } from '../../common/styles/Layout';
import { ThemeColours } from '../../common/styles/ThemeColours';
import { FONT_STACK } from '../../common/styles/constants';
import { onMobile } from '../../common/styles/onMobile';
import { FeedbackFooterSection } from '../FeedbackFooterSection/FeedbackFooterSection';

export const FooterBackground = styled.div`
  background-color: ${ThemeColours.mono100};
  ${PAGE_CONTAINER};
  ${FONT_STACK}
`;

export const TextSection = styled.div`
  border-bottom: solid 1px ${ThemeColours.mono300};
  color: ${ThemeColours.mono700};
  font-size: 16px;
  line-height: 1.5;
  margin-top: 100px;
  padding-bottom: 24px;
  padding-top: 40px;
  white-space: pre-line;

  ${onMobile} {
    font-size: 14px;
  }
`;

export const StyledFeedbackFooterSection = styled(FeedbackFooterSection)`
  margin-top: 0;
  width: 100%;
`;
